<template>
    <div class="container fixedHeight">
        <textarea v-model="internalText" :class="['form-control', 'rounded-0', 'col-12', {'border-danger': errorStyle}]" :rows="rows" readonly="true"></textarea>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueClipboard from 'vue-clipboard2';    

    Vue.use(VueClipboard);

    export default {
        props: {
            lines: {
                type: Array,
                default: []            
            },
            text: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: "Clipboard"
            },
            errorStyle: {
                type: Boolean,
                default: false
            },
            employerId: {
                type: String,
                default: null
            },
            validationType: {
                type: String,
                default: null
            },
        },
        computed: {
            rows() {
                return this.lines.length < 10 ? 10 : this.lines.length;
            },
            buttons() { 
                if(this.validationType == 'error' || this.validationType == 'parse') {
                    return "$Close";
                }
                return []; 
            },
            buttonsCustom() {
                
                if (this.validationType == 'warning'){
                    return [
                        {  
                            name: "*Yes, I want to make changes",
                            onClick: () => {return false;}
                        },
                        {
                            name: "No, Proceed",
                            onClick: async () => {return true;}
                        }]
                } else if (this.validationType == 'error' || this.validationType == 'parse') {
                    return [
                        {
                            name: "Copy to Clipboard",
                            onClick: () => this.copyToClipboard()
                        },
                        {
                            name: "Download Errors",
                            onClick: async () => await this.downloadErrors()
                        }]
                }
            },
            internalText() {
                return this.lines.join('\n') || this.text
            }
        },
        created() {
        },
        methods: {
            copyToClipboard(){
                this.$copyText(this.internalText).then(function(e) {
                    toastService.success(`Copied text to clipboard.`);
                    console.log(e.text);
                }, function (e) {
                    toastService.error("Error copying text to clipboard.  It could be a browser incompatibility issue.  Try copying with ctrl + c.")
                });
            },
            async downloadErrors(){
                this.busy = true;

                var errors = []
                this.lines.forEach((line) => {
                    errors.push({error: line});
                });

                var dto = {errors: errors};
        
                await romeApi.postDownload(`employer/${this.employerId}/enrollment/errors/download`, null, dto); 

                this.busy = false; 
            },
        },        
    }
</script>

<style lang="scss" scoped>
    .fixedHeight{
        overflow-y: scroll;
        max-height: 500px; 
    }
</style>



// WEBPACK FOOTER //
// src/action-items/types/EnrollmentValidationErrors.vue